module.exports = __webpack_public_path__ + "img/blog_10.a472cacd.jpg";